
import Vue, { PropType } from "vue";
import { DialogCloseType, DialogI } from "@/types/dialog";
import BaseDialog from "./BaseDialog.vue";
import TextField from "@/components/form/inputs/TextField.vue";
import Btn from "@/components/v2/base/Btn.vue";
import { validator } from "@/utils/validators";
import { PrestonUser } from "@prestonly/preston-common";
// import { PrestonUser, UserMetadataAction } from "@prestonly/preston-common";

export default Vue.extend({
  name: "ChangeNicknameDialog",
  components: {
    BaseDialog,
    TextField,
    Btn,
  },
  mixins: [validator],
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  data() {
    return {
      nickname: "",
      valid: false,
    };
  },
  computed: {
    user(): PrestonUser {
      return this.$store.getters["user/getUser"];
    },
  },
  methods: {
    async submit(): Promise<void> {
      await this.validate();

      if (!this.valid) return;

      this.dialog.close({
        type: DialogCloseType.SUBMITTED,
        payload: {
          nickname: this.nickname,
        },
      });
    },

    async deleteNickname(): Promise<void> {
      console.log("delete");

      //   const payload: Partial<PrestonUser> = { nickname: "" };

      //   await this.$store.dispatch("user/patchUser", {
      //     action: UserMetadataAction.NICKNAME,
      //     payload,
      //   });
    },
  },
});
